<template>
  <div id="contents">
    <div id="exBasket" class="container">
      <h3 class="stitle mb50">
        예약현황
        <!-- <div class="tit_btnbox">
          <a class="btn_color" href="SCR_KH01-RP-017.html">체험실 입력 양식 파일 다운로드</a>
          <a class="btn_color2" href="#">삭제</a>
        </div> -->
      </h3>
      <h4 class="stitle2 mb10 tleft">예약확인</h4>
      <div class="tb_wrap mb30 res_tbl_grid_wrap">
        <table class="tb_basic">
          <caption>예약정보</caption>
          <tbody>
            <tr>
              <th class="tbg cw120">예약번호</th>
              <td class="tleft">{{ bundleRvNo }}</td>
              <th class="tbg cw120">예약상태</th>
              <td class="tleft">{{ reserveInfo.rvSitu }}</td>
            </tr>
            <tr>
              <th class="tbg cw120">예약일</th>
              <td class="tleft">{{ reserveInfo.rvDtm }}</td>
              <th class="tbg cw120">예약자명</th>
              <td class="tleft">{{ reserveInfo.userName }}</td>
            </tr>
            <tr>
              <th class="tbg cw120">휴대폰</th>
              <td class="tleft">{{ reserveInfo.userMobileNum }}</td>
              <th class="tbg cw120">이메일</th>
              <td class="tleft">{{ reserveInfo.userEmail }}</td>
            </tr>
            <tr v-if="reserveInfo.hpOrgInfoId > 0">
              <th class="tbg cw120">단체명</th>
              <td class="tleft">{{ reserveInfo.orgName }}</td>
              <th class="tbg cw120">학년</th>
              <td class="tleft">{{ reserveInfo.gradeNm }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!--//체험관 예약 확인-->
      <!--예약정보 -->
      <div v-if="showExhpSel" class="mb20">
        <accordion always-open ref="accordion" class="ticket-accordion">
          <accordion-item>
            <template slot="accordion-trigger">
              <h4 class="stitle2 mb10 tleft">체험실 선택현황</h4>
            </template>
            <template slot="accordion-content">
              <div class="content-block">
                <div class="tb_wrap mb30">
                  <table class="tb_basic">
                    <thead>
                      <tr class="tbg">
                        <th scope="col" width="10%">순번</th>
                        <th scope="col" width="15%">회차</th>
                        <th scope="col" width="30%">분야명</th>
                        <th scope="col" width="30%">체험실명</th>
                        <th scope="col" width="15%" style="text-align: middle">예약인원</th>
                      </tr>
                    </thead>
                    <tbody v-if="exhpHallList.length < 1">
                      <tr><td class="day" colspan="5">선택된 체험실이 없습니다.</td></tr>
                    </tbody>
                    <tbody v-else>
                      <tr v-for="(exhp, i) in exhpHallList" :key="exhp.rownum">
                        <td class="day" width="10%" style="text-align: center">{{ exhp.rownum }}</td>
                        <td class="day" width="15%" style="text-align: center">{{ exhp.scheSeqNo }}</td>
                        <td class="day" width="30%" style="text-align: center">{{ exhp.streetNm }}</td>
                        <td class="day" width="30%" style="text-align: center">{{ exhp.exhpHallNm }}</td>
                        <td class="day" width="15%" style="text-align: center">{{ exhp.pcnt }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </template>
          </accordion-item>
        </accordion>
      </div>
      <!--//예약정보 -->

      <h4 class="stitle2 mb10 tleft">결제내역</h4>
      <div class="tb_wrap mb30 res_tbl_grid_wrap">
        <table class="tb_basic">
          <caption>결제내역 정보 리스트</caption>
          <tbody>
            <tr>
              <th class="tbg cw120">결제상태</th>
              <td class="tleft">{{ reserveInfo.paySituNm }}</td>
              <th class="tbg cw120">결제수단</th>
              <td class="tleft">
                <p>{{ reserveInfo.payMethodNm }}</p>
                <p v-if="reserveInfo.payMethod == '02'">{{ reserveInfo.cardHeadName }}&nbsp;{{ reserveInfo.cardNo }}</p>
                <p v-else-if="reserveInfo.payMethod == '03'">{{ reserveInfo.ctBankNm }}&nbsp;({{ reserveInfo.ctDpserNm }})</p>
                <template v-else-if="reserveInfo.payMethod == '04'">
                  <p>{{ reserveInfo.nobankDpsBankNm }}&nbsp;({{ reserveInfo.nobankAccNo }})</p>
                  <p>예금주:{{ reserveInfo.nobankDpser }}</p>
                </template>
              </td>
              <th class="tbg cw120">결제일</th>
              <td class="tleft">{{ reserveInfo.payDtm }}</td>
            </tr>
            <!-- 무통장입금, 결제중 -->
            <tr v-if="reserveInfo.rvProgSitu == '02' && reserveInfo.payMethod == '04' && reserveInfo.paySitu == '01'">
              <th class="tbg cw120">
                무통장입금
                <br />
                안내
              </th>
              <td class="ei_td04" colspan="5">
                <p class="ei_countp">
                  입금계좌:
                  <span class="ei_acount">{{ reserveInfo.nobankDpsBankNm }}&nbsp;{{ reserveInfo.nobankAccNo }}</span>
                </p>
                <p>예금주:{{ reserveInfo.nobankDpser }}</p>
                <p class="ei_red">입금마감일:{{ reserveInfo.nobankDpsBdtDt }}</p>
              </td>
            </tr>
            <!-- 결제완료 -->
            <tr v-if="reserveInfo.paySitu == '02'">
              <th class="tbg cw120">증빙서류</th>
              <td class="ei_td05" colspan="5">
                <!-- 카드 -->
                <div v-if="reserveInfo.payMethod == '02'">
                  카드매출전표&nbsp;&nbsp;
                  <span class="ticket_btnbox"><a @click="() => openReceipt('card')" class="btn_detail openPopup">인쇄</a></span>
                </div>
                <div v-else-if="reserveInfo.payMethod == '03'">
                  현금영수증&nbsp;&nbsp;
                  <span class="ticket_btnbox"><a @click="() => openReceipt('cash')" class="btn_detail openPopup">인쇄</a></span>
                </div>
                <div v-else-if="reserveInfo.payMethod == '04'">
                  현금영수증&nbsp;&nbsp;
                  <span class="ticket_btnbox"><a @click="() => openReceipt('cash')" class="btn_detail openPopup">인쇄</a></span>
                </div>
              </td>
            </tr>
            <!-- 단체 -->
            <tr v-if="reserveInfo.groupPersDiv == '01' && reserveInfo.rvProgSitu != '05'">
              <th class="tbg cw120">확약서</th>
              <td class="tleft" colspan="5">
                <span v-if="reserveInfo.appointId || reserveInfo.rvProgSitu === '10'">작성</span>
                <span v-else>미작성</span>
                <!-- 작성되지 않았거나 가예약인 경우 작성 가능 , 예약취소이면 작성 불가능 -->
                <ResevePledgePopup
                  v-if="reserveInfo.rvProgSitu != '03' && reserveInfo.rvProgSitu != '05' && reserveInfo.rvProgSitu !== '10' && !reserveInfo.appointId"
                  :bundleRvNo="bundleRvNo"
                >
                  <span class="ticket_btnbox">
                    <a class="btn_write openPopup">작성</a>
                  </span>
                </ResevePledgePopup>
                <ResevePledgePopup v-if="reserveInfo.appointId" ref="rpp" :bundleRvNo="bundleRvNo">
                  <span></span>
                </ResevePledgePopup>
                <ResevePledgePopupView v-if="reserveInfo.appointId" :bundleRvNo="bundleRvNo" :openRpp="openRpp">
                  <span class="ticket_btnbox">
                    <a class="btn_write openPopup">인쇄</a>
                  </span>
                </ResevePledgePopupView>
              </td>
              <!--
              <th class="tbg cw120">할인면제자</th>
              <td class="tleft" colspan="3">
                <span v-if="reserveInfo.verificationId && reserveInfo.rvProgSitu != '05'">작성</span>
                <span v-else>미작성</span>
                <ReseveVerificationPopup v-if="!reserveInfo.verificationId && reserveInfo.rvProgSitu != '05'" :bundleRvNo="bundleRvNo">
                  <span class="ticket_btnbox">
                    <a class="btn_write openPopup">작성</a>
                  </span>
                </ReseveVerificationPopup>
                <ReseveVerificationPopup v-if="reserveInfo.verificationId" ref="rvp" :bundleRvNo="bundleRvNo">
                  <span></span>
                </ReseveVerificationPopup>
                <ReseveVerificationPopupView v-if="reserveInfo.verificationId" :bundleRvNo="bundleRvNo" :openRvp="openRvp">
                  <span class="ticket_btnbox">
                    <a class="btn_write openPopup">확인</a>
                  </span>
                </ReseveVerificationPopupView>
              </td>
              -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="tb_wrap">
        <table class="tb_basic">
          <caption>상품 예약 목록</caption>
          <thead>
            <tr class="tbg">
              <th scope="col">체험일</th>
              <th scope="col">상품</th>
              <th scope="col">회차</th>
              <th scope="col">인원</th>
              <th scope="col">금액</th>
              <th scope="col">할인금액</th>
              <th scope="col">취소여부</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rv, i) in detailList" :key="rv.pdRvNo">
              <td v-if="i === 0" :rowspan="detailList.length" data-label="체험일">{{ rv.expVisitRvdtF }}</td>
              <td data-label="상품">
                {{ rv.pdNm }}
                <br />
                <a v-if="rv.rvProgSitu === '03'" class="btn_print" @click="() => openConfirmCard(rv.pdRvNo)">확인증</a>
              </td>
              <td data-label="회차">
                {{ rv.scheSeqNm }}({{ rv.scheTm }})
                <ReseveDetailPopup :pdRvNo="rv.pdRvNo">
                  <span class="ticket_btnbox"><a class="btn_detail">상세보기</a></span>
                </ReseveDetailPopup>
              </td>
              <td class="tleft" data-label="인원">
                <ul class="tlist1">
                  <li>
                    <strong>체험자</strong>
                    <span>{{ rv.experPcnt }}인</span>
                  </li>
                  <li v-if="rv.leaderPcnt > 0">
                    <strong>보호자</strong>
                    <span>{{ rv.leaderPcnt }}인</span>
                  </li>
                </ul>
              </td>
              <td class="tright" data-label="금액">{{ _wonFormat(rv.rvAmt + rv.dcAmt) }}</td>
              <td class="tright" data-label="할인금액">{{ _wonFormat(rv.dcAmt) }}</td>
              <!-- <td class="tright">{{ _wonFormat(rv.rvAmt) }}</td> -->
              <td data-label="취소여부">
                <span v-if="rv.rvCancelYn === 'Y'">
                  취소
                  <br />
                  ({{ rv.rvCancelDtm }})
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="totalPriceBox mb50">
        <ul class="div3">
          <li>
            <strong>체험금액</strong>
            <span>
              <i class="fs_big tcolor1">{{ _priceFormat(totOriginPrice) }}</i>
              원
            </span>
          </li>
          <li class="price_icon1">
            <strong>할인금액</strong>
            <span>
              <i class="fs_big">{{ _priceFormat(totDcPrice) }}</i>
              원
            </span>
          </li>
          <!-- <li class="price_icon2">
            <strong>취소수수료</strong>
            <span>
              <i class="fs_big">0</i>
              원
            </span>
          </li> -->
          <li class="price_icon3">
            <strong>총결제금액</strong>
            <span>
              <i class="fs_big">{{ _priceFormat(totSalePrice) }}</i>
              원
            </span>
          </li>
        </ul>
      </div>
      <!-- notPledegeOnly => 평일단체예약제 확약서 예약만 가능 -->
      <div class="btn_area">
        <router-link class="btn btn_bg gray" :to="`/${currentRouteType}/reservations`">예약목록</router-link>
        <a class="btn btn_bg line" v-if="canModify" @click="goModify">예약변경</a>
        <router-link class="btn btn_bg line" v-if="cancelPoss" :to="`/${currentRouteType}/reservations/${bundleRvNo}/cancel`">예약취소</router-link>
        <router-link class="btn btn_bg color" v-if="paymentChk()" :to="`/${currentRouteType}/reservations/${bundleRvNo}/payment`">결제하기</router-link>
        <!-- <a class="btn btn_bg color" href="SCR_KH01-RP-009.html">결제하기</a> -->
      </div>
    </div>
    <!--// .container-->
  </div>
</template>

<script>
import { getReservation } from '@/api/api_reserve';
import { openConfirmCardPopup, toJspPage } from '@/utils/reserve';
import ReseveDetailPopup from '@/components/popup/ReseveDetailPopup';
import ResevePledgePopup from '@/components/popup/ResevePledgePopup';
import ResevePledgePopupView from '@/components/popup/ResevePledgePopupView';
import ReseveVerificationPopup from '@/components/popup/ReseveVerificationPopup';
import ReseveVerificationPopupView from '@/components/popup/ReseveVerificationPopupView';
import Accordion from '@/components/common/Accordion.vue';
import AccordionItem from '@/components/common/AccordionItem.vue';

export default {
  components: { ReseveDetailPopup, ResevePledgePopup, ResevePledgePopupView, ReseveVerificationPopup, ReseveVerificationPopupView, Accordion, AccordionItem },
  data() {
    return {
      message: '',
      bundleRvNo: '',
      reserveInfo: {},
      exhpHallList: [],
      detailList: [],
      payInfo: {},
      showExhpSel: false,
      cancelPoss: false,
    };
  },
  computed: {
    totOriginPrice() {
      return this.detailList.reduce((a, e) => a + e.rvAmt + e.dcAmt, 0);
    },
    totDcPrice() {
      return this.detailList.reduce((a, e) => a + e.dcAmt, 0);
    },
    totSalePrice() {
      return this.detailList.reduce((a, e) => a + e.rvAmt, 0);
    },
    canModify() {
      return this.reserveInfo.changePossYn === 'Y' && this.detailList.findIndex((e) => e.changePossYn === 'Y') > -1;
    },
  },
  methods: {
    async initialLoad() {
      //const host = window.location.host;
      //if (host === 'www.koreajobworld.or.kr') {
      await this.$loadScript('https://pgweb.tosspayments.com/WEB_SERVER/js/receipt_link.js'); //service
      //} else {
      //  await this.$loadScript('http://pgweb.uplus.co.kr:7085/WEB_SERVER/js/receipt_link.js'); //test
      //}
    },
    openReceipt(type) {
      if (window.showReceiptByTID) {
        if (type === 'card') {
          showReceiptByTID(this.payInfo.shopId, this.payInfo.dealNo, this.payInfo.authdata);
        } else if (type === 'cash') {
          showCashReceipts(this.payInfo.shopId, this.payInfo.orderNo, '001', this.payInfo.payType, this.payInfo.serviceType);
        }
      }
    },
    openRpp() {
      this.$refs.rpp.openEdit();
    },
    openRvp() {
      this.$refs.rvp.openEdit();
    },
    goModify() {
      alert(
        '1. 체험일 및 체험상품은 변경 불가(예약 취소 후 다시 예약 진행)\r\n2. 체험 인원 및 회차 변경 시 체험실 재선택이 필요 할 수 있습니다.(기존 체험실 자동 삭제)\r\n3. 예약변경적용(저장) 버튼을 클릭하셔야 변경내용 적용이 완료됩니다.\r\n※문의 사항은 고객센터(☏ 1644-1333)를 이용해주세요.',
      );
      this.$router.push(`/${this.currentRouteType}/reservations/${this.bundleRvNo}/change`);
      //toJspPage('/resvr/reserveModify.do', { bundleRvNo: this.bundleRvNo, expVisitRvdt: this.reserveInfo.expVisitRvdt });
    },
    openConfirmCard(pdRvNo) {
      openConfirmCardPopup(pdRvNo);
    },
    paymentChk() {
      // 가예약 확인
      let chkRvProgSitu = this.reserveInfo.rvProgSitu === '01';

      // 확약서 전용 상품 확인
      const onlyPledegeList = ['724', '898', '916']; // 확약서예약 만 사용할 상품번호 추가
      let chkPledege = this.detailList.some((reserve) => {
        return onlyPledegeList.every((item) => reserve.pdNo.toString().includes(item));
      });

      return !chkPledege && chkRvProgSitu;
    },
  },
  created() {
    this.initialLoad();
    this.bundleRvNo = this.$route.params.bundleRvNo;
    getReservation(this.bundleRvNo)
      .then((data) => {
        if (data.success) {
          const { reserveInfo, detailList, exhpHallList, payInfo } = data.response;
          this.reserveInfo = reserveInfo;
          this.detailList = detailList;
          this.exhpHallList = exhpHallList;
          this.payInfo = payInfo || {};

          this.showExhpSel = this.detailList?.some((e) => {
            //return '02|10'.includes(e.pdDiv) && '03|10'.includes(e.rvProgSitu);
            return '01' === e.capaPcntType && '03|10'.includes(e.rvProgSitu);
          });

          this.cancelPoss = this.detailList?.some((e) => 'Y' === e.cancelPossYn);
        }
      })
      .catch((e) => {
        alert('오류가 발생하였습니다.');
      });
  },
};
</script>

<style lang="scss" scoped>
.ticket_btnbox a {
  cursor: pointer;
}
</style>
